<template>
  <ppt-modal id="text-selector-help-modal">
    <header slot="header">
      <button type="button" class="close" data-dismiss="modal">
        <span>&times;</span>
      </button>
      <h4 class="modal-title">Text Selector Rules</h4>
    </header>
    <section slot="body">
      <table class="table">
        <thead>
          <tr>
            <th>Correct</th>
            <th>Incorrect</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>AA, 44, 76s, KJo</td>
            <td></td>
          </tr>
          <tr>
            <td>AA,44,76s,KJo (don't need spaces between commas)</td>
            <td></td>
          </tr>
          <tr>
            <td>44, KJo, 76s, AA (order doesn't matter)</td>
            <td></td>
          </tr>
          <tr>
            <td>kk, t7s, kqo (case insensitive)</td>
            <td></td>
          </tr>
          <tr>
            <td>AhKh (specific suits)</td>
            <td></td>
          </tr>
          <tr>
            <td>TT</td>
            <td>1010</td>
          </tr>
          <tr>
            <td>76s</td>
            <td>67s</td>
          </tr>
          <tr>
            <td>AK (shortcut for AKs, AKo)</td>
            <td></td>
          </tr>
          <tr>
            <td>JJ+ (shortcut for JJ, QQ, KK, AA)</td>
            <td>AA+ (can't go any higher than ace)</td>
          </tr>
          <tr>
            <td>JJ, QQ, KK, AA (shortcuts aren't required)</td>
            <td></td>
          </tr>
          <tr>
            <td>44- (shortcut for 44, 33, 22)</td>
            <td>22- (can't go any lower than two)</td>
          </tr>
          <tr>
            <td>K8s+ (shortcut for K8s, K9s, KTs, KJs, KQs)</td>
            <td></td>
          </tr>
          <tr>
            <td>98s+ (shortcut for 98s, T9s, JTs, QJs, KQs, AKs)</td>
            <td>AKs+ (can't go any higher)</td>
          </tr>
          <tr>
            <td>97s+ (shortcut for 97s, T8s, J9s, QTs, KJs, AQs)</td>
            <td></td>
          </tr>
          <tr>
            <td>99-55</td>
            <td>KJs-K7o, KJs-87s</td>
          </tr>
          <tr>
            <td></td>
            <td>55-99, K7s-KJs</td>
          </tr>
        </tbody>
      </table>
    </section>
  </ppt-modal>
</template>

<script>
import PPTModal from '@/components/utilities/modal';

export default {
  name: 'text-selector-help-modal',
  components: {
    'ppt-modal': PPTModal,
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/hand-range/text-selector/help-modal.vue